export const API_BASE_URL = 'https://serverless-production.theezy.com';